import React, { useEffect, useState, useCallback } from "react";
import BodyPhotosDelete from "./BodyPhotosDelete";
import BodyPhotosAdd from "./BodyPhotosAdd";
import BodyPhotosSetShare from "./BodyPhotosSetShare";
import BodyPhotosDate from "./BodyPhotosDate";
import BodyPhotoShares from "./share/BodyPhotoShares";
import Spinner from "../../../../common/Spinner";
import { BodyPhotoDto } from "../../../../types/types";
import { useTranslation } from "react-i18next";
import BodyPhotoTags from "./tags/BodyPhotoTags";

interface BodyPhotosOptionsProps {
  photos: BodyPhotoDto[] | null;
  clientId?: string;
  onRefresh: () => void;
}

const BodyPhotosOptions: React.FC<BodyPhotosOptionsProps> = ({ clientId, photos, onRefresh }) => {
  const { t } = useTranslation("global");

  return (
    <div>
      <div style={{ display: "flex", flexDirection: "column", gap: ".7rem", marginTop: "1rem" }}>
        {!photos ? (
          <Spinner />
        ) : photos.length === 0 ? (
          <div>{t("cards.no_photos_added")}</div>
        ) : (
          photos.map((p, idx) => (
            <div
              key={p.id + idx}
              style={{
                display: "flex",
                padding: 6,
                background: "var(--color04)",
                borderRadius: 6,
                gap: "0.5rem",
              }}
            >
              <div style={{ flex: "0 0 40%", maxWidth: "15rem" }}>
                <img
                  src={p.photoUrl}
                  alt={`${idx}`}
                  style={{ width: "100%", height: "auto", objectFit: "cover", borderRadius: 4 }}
                  onContextMenu={(e) => e.preventDefault()}
                />
                <div style={{ display: "flex", justifyContent: "space-between", marginTop: "0.5rem" }}>
                  <BodyPhotosDelete photoId={p.id} photoUrl={p.photoUrl} onDeleted={() => onRefresh()} />
                  <BodyPhotosDate photo={p} onRefresh={() => onRefresh()} />
                </div>
              </div>
              <div style={{ flex: "1" }}>
                <BodyPhotoTags photoId={p.id} />
                <BodyPhotoShares photoId={p.id} />
              </div>
            </div>
          ))
        )}
      </div>

      <div>
        {photos && photos.length >= 15 ? (
          <div>Zbyt wiele zdjęć</div>
        ) : (
          <BodyPhotosAdd clientId={clientId} onUploaded={() => onRefresh()} />
        )}
      </div>
    </div>
  );
};

export default BodyPhotosOptions;